/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreMenuPreSignedUrl } from '../../models/store-menu-pre-signed-url';

export interface StoresStoreIdMenusMenuIdGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  menuId: string;
}

export function storesStoreIdMenusMenuIdGet(http: HttpClient, rootUrl: string, params: StoresStoreIdMenusMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreMenuPreSignedUrl>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdMenusMenuIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreMenuPreSignedUrl>;
    })
  );
}

storesStoreIdMenusMenuIdGet.PATH = '/stores/{storeId}/menus/{menuId}';
